import React, { useState } from 'react'
import { Form, Input, Button, Alert } from 'antd'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import PhoneInput from 'react-phone-number-input'
import flags from 'react-phone-number-input/flags'
import { logIn } from 'redux/actions/login'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'

import styles from './style.module.scss'

const LOGIN_METHOD = {
  PHONE: 'phone',
  LOGIN: 'login'
}

const Login = ({ user: { loading, error }, logIn, intl: { formatMessage } }) => {
  const [enterMethod, setEnterMethod] = useState(LOGIN_METHOD.PHONE)
  const [form] = Form.useForm()

  const onSubmit = values => logIn(values, enterMethod)

  return (
    <div className={styles.wrapper}>
      <div className={styles.form}>
        <h3>{formatMessage({ id: 'page.login.title' })}</h3>

        <Form
          form={form}
          layout="vertical"
          hideRequiredMark
          onFinish={onSubmit}
        >
          {error && (
            <Alert
              className={styles.error}
              description={formatMessage({ id: error })}
              type="error"
            />
          )}

          {enterMethod === LOGIN_METHOD.PHONE && (
            <Form.Item
              name="phone"
              rules={[{ required: true, message: formatMessage({ id: 'page.login.phone-required' }) }]}
            >
              <PhoneInput
                name="phone"
                country="RU"
                type="tel"
                placeholder={formatMessage({ id: 'page.login.phone' })}
                flags={flags}
              />
            </Form.Item>
          )}
          {enterMethod === LOGIN_METHOD.LOGIN && (
            <Form.Item
              name="login"
              rules={[{ required: true, message: formatMessage({ id: 'page.login.login-required' }) }]}
            >
              <Input
                name="login"
                size="large"
                placeholder={formatMessage({ id: 'page.login.login' })}
              />
            </Form.Item>
          )}

          <Form.Item
            name="password"
            rules={[{ required: true, message: formatMessage({ id: 'page.login.password-required' }) }]}
          >
            <Input
              size="large"
              type="password"
              placeholder={formatMessage({ id: 'page.login.password' })}
            />
          </Form.Item>

          <Button
            type="primary"
            size="large"
            htmlType="submit"
            loading={loading}
          >
            {formatMessage({ id: 'page.login.submit-text' })}
          </Button>

          {enterMethod === LOGIN_METHOD.PHONE && (
            <button
              className={styles.enterMethod}
              onClick={() => setEnterMethod(LOGIN_METHOD.LOGIN)}
              type="button"
            >
              {formatMessage({ id: 'page.login.by-login' })}
            </button>
          )}
          {enterMethod === LOGIN_METHOD.LOGIN && (
            <button
              className={styles.enterMethod}
              onClick={() => setEnterMethod(LOGIN_METHOD.PHONE)}
              type="button"
            >
              {formatMessage({ id: 'page.login.by-phone' })}
            </button>
          )}
        </Form>
      </div>
    </div>
  )
}

export default errorBoundaryEnhancer(connect(({ user }) => ({ user }), { logIn })(injectIntl(Login)))
